export class CheckListItemModel {
  constructor(public id: string, public name: string, public innerContent?: string, public translate: boolean = false) {}

  public checked = false;
  public content?: any = null;
  public group = '';
  public ticketNumber: string;
  public required: boolean;
}
